<div class="page">
  <!-- top bar -->
  <section class="top-bar" [class.no-pointer]="loading && false">
    <!-- search left -->
    <div class="search-wrap">
      <div class="d-flex align-items-center">
        <div class="search-bar-wrap">
          <!-- search bar -->
          <app-field-text
            [model]="SEARCH.term"
            (modelChange)="SEARCH.term = $event"
            (enter)="search(undefined, undefined, 'enter')"
            [placeholder]="'mails_search_placeholder' | translate">
          </app-field-text>
          <!-- advanced search -->
          @if (advancedSearchOpen) {
          <div class="advanced-search-wrap">
            <!-- advanced search head -->
            <div class="title">
              <span>{{'misc_advanced_search' | translate}}</span>
              <span class="x" (click)="advancedSearchOpen = false"><i
                  class="im-icon im-icon-x-light"></i></span>
            </div>
            <!-- advanced search body -->
            <div class="row display-row">
              <div class="col-6">
                <app-field-text
                  [model]="SEARCH.term"
                  (modelChange)="SEARCH.term = $event"
                  (enter)="search(undefined, undefined, 'enter')"
                  [label]="'mails_search_term' | translate"
                  [placeholder]="'mails_search_term_placeholder' | translate">
                </app-field-text>
              </div>
              <div class="col-3">
                <app-field-date
                  [model]="SEARCH.date_from"
                  (modelChange)="SEARCH.date_from = $event;"
                  [label]="'mails_search_date_from' | translate"
                  [placeholder]="'misc_date_placeholder' | translate"
                  positionDateSelector="bottom"
                  width="100%"></app-field-date>
              </div>
              <div class="col-3">
                <app-field-date
                  [model]="SEARCH.date_until"
                  (modelChange)="SEARCH.date_until = $event;"
                  [label]="'mails_search_date_until' | translate"
                  [placeholder]="'misc_date_placeholder' | translate"
                  positionDateSelector="bottom"
                  width="100%"></app-field-date>
              </div>
            </div>
            <div class="row display-row">
              <div class="col-6">
                <app-field-text
                  [model]="SEARCH.from"
                  (modelChange)="SEARCH.from = $event"
                  (enter)="search(undefined, undefined, 'enter')"
                  [label]="'mails_search_from' | translate"
                  [placeholder]="'mails_search_from_placeholder' | translate">
                </app-field-text>
              </div>
              <div class="col-6">
                <app-field-select
                  [label]="'mails_search_environment' | translate"
                  [model]="SEARCH.environment"
                  [options]="options.environment"
                  (modelChange)="SEARCH.environment = $event;"></app-field-select>
              </div>
            </div>
            <div class="row display-row">
              <div class="col-6">
                <app-field-text
                  [model]="SEARCH.to"
                  (modelChange)="SEARCH.to = $event"
                  (enter)="search(undefined, undefined, 'enter')"
                  [label]="'mails_search_to' | translate"
                  [placeholder]="'mails_search_to_placeholder' | translate">
                </app-field-text>
              </div>
              <div class="col-6">
                <app-field-radios
                  [label]="'mails_search_attachment' | translate"
                  [canUncheck]="true"
                  [model]="SEARCH.hasAttachment"
                  (modelChange)="SEARCH.hasAttachment = $event"
                  [options]="options.attachment"
                  [optionWidth]="110">
                </app-field-radios>
              </div>
            </div>
            <div class="row display-row">
              @if (user?.projects?.length > 1) {
              <div class="col-6">
                <app-field-select
                  [label]="'mails_search_project' | translate"
                  [placeholder]="'mails_search_project_placeholder' | translate"
                  [model]="SEARCH.projectId"
                  [options]="user.projects"
                  (modelChange)="SEARCH.projectId = $event;"></app-field-select>
              </div>
              }
              <div class="col-6">
                <app-field-radios
                  [label]="'mails_search_error' | translate"
                  [canUncheck]="true"
                  [model]="SEARCH.isError"
                  (modelChange)="SEARCH.isError = $event"
                  [options]="options.error"
                  [optionWidth]="110">
                </app-field-radios>
              </div>
            </div>
            <!-- advanced search foot -->
            <div class="sep"></div>
            <div class="foot">
              <!-- <button (click)="search(true);"
                class="button-link underline"><span>{{'misc_reset_search' |
                  translate}}</span></button> -->
              <button (click)="search();"
                class="button default dark text-center d-block">{{'misc_search_btn'
                | translate}}</button>
            </div>
          </div>
          }
          @if (advancedSearchOpen) {
          <div class="advanced-search-backdrop"
            (click)="advancedSearchOpen = false"></div>
          }
        </div>
        <!-- advanced search button -->
        <button (click)="advancedSearchOpen = true; handleTypeaheads();"
          class="button-link underline pt-xxs pb-xxs">{{'misc_advanced_search' |
          translate}}</button>
      </div>
      @if (showResults > 1) {
      <div class="search-sub-wrap d-flex">
        <div class="d-flex align-items-start">
          @if (SEARCHED?.length) {
          <div class="tags">
            @for (tag of SEARCHED; track tag) {
            @if (tag.key!=='search') {
            <div class="tag d-inline-flex align-items-center">
              <span><span class="title">{{tag.title}}: </span><span
                  class="value">{{tag.value}}</span></span>

            </div>
            }
            }
          </div>
          }
          <!-- reset search button -->
          <!-- @if (SEARCHED?.length) {
            <button (click)="search(true)" class="button-link underline">{{'misc_reset_search' | translate}}</button>
          } -->
        </div>
      </div>
      }
    </div>
    <!-- profile right -->
    <div class="profile-wrap d-flex align-items-center">
      <app-profile-section></app-profile-section>
    </div>
  </section>
  <!-- end top bar -->

  @if (showResults > 1) {
  <!-- title -->
  <h1 class>{{'mails_title' | translate}} @if (ready) {
    <span [class.saving]="loading" class="saving--pre">({{totalRows}})</span>
    }</h1>
  <!-- table -->
  <div class="table-wrap">
    <app-table
      [heads]="heads"
      [data]="items"
      [sort]="SORT"
      [RPP]="RPP"
      [startRow]="startRow"
      [totalRows]="totalRows"
      [loading]="loading"
      [ready]="ready"
      [timeout]="0"
      [linkElement]="true"
      [selected]="selectedItemId"
      [emptyState]="'mails_emptystate' | translate"
      (sortChange)="clickSort($event.code, $event.dir)"
      (clickData)="tableClick($event.item)"
      (clickAction)="actionClick($event.item, $event.action)"
      (startRowChange)="changeStartRow($event)"></app-table>
  </div>
  }

  <!-- detail -->
  <app-slideout-wrap [selectedItemId]="selectedItemId"
    [selectedItemLoading]="selectedItemLoading" [selectedItem]="selectedItem"
    (emitClose)="closeDetail()">
    <app-mail-slideout [open]="selectedItemId" [ready]="!selectedItemLoading"
      (dismiss)="this.closeDetail()" (resent)="resent()" [mail]="selectedItem"
      [error]="!selectedItemLoading && !selectedItem"></app-mail-slideout>
  </app-slideout-wrap>
</div>